import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

export interface RadioSelectOption {
  name: string;
  value: string;
  price: number | null; // null если не хотим показывать блок с ценой
}

@UntilDestroy()
@Component({
  selector: 'app-radio-select[options]',
  templateUrl: './radio-select.component.html',
  styleUrls: ['./radio-select.component.scss']
})
export class RadioSelectComponent {

  @Input() options: RadioSelectOption[] = [];

  @Input() defaultValue: string;
  @Output() notifyChange: EventEmitter<string> = new EventEmitter();

  constructor() {
  }

  onChange = (value: string) => {
    this.notifyChange.emit(value);
  };
}
